import { scaleLinear } from 'd3-scale';

export function sizeScale(margin) {
  if (isNaN(margin)) {
    return 0;
  } else {
    let assignSize = scaleLinear()
      .domain([0, 5, 10, 15, 20, 25, 30])
      .range([5, 10, 20, 30, 40, 50, 60, 70])
      .clamp(true);

    let finalSize = assignSize(margin * 100);

    return finalSize;
  }
}
